export enum BilletOrderTypeEnum {
  SIMULTANEOUS = 1,
  OCO = 2,
}
